import { FC } from 'react';

import { Banner, Button, ButtonProps, Text, Title } from '@hh.ru/magritte-ui';

interface Props {
    visible?: boolean;
    showClose?: boolean;
    showBorder?: boolean;
    stretched?: boolean;
    title?: string;
    description?: string;
    buttonBase?: string;
    buttonAdditional?: string;
    buttonBaseProps?: Pick<ButtonProps, 'onClick' | 'data-qa'>;
    buttonAdditionalProps?: Pick<ButtonProps, 'onClick' | 'data-qa'>;
    dataQa?: string;
}

const MagritteBannerFacade: FC<Props> = ({
    visible,
    showClose,
    showBorder,
    stretched,
    title,
    description,
    buttonBase,
    buttonAdditional,
    buttonBaseProps = {},
    buttonAdditionalProps = {},
    dataQa,
}) => (
    <Banner
        visible={visible}
        showClose={showClose}
        showBorder={showBorder}
        stretched={stretched}
        style="contrast"
        data-qa={dataQa}
        title={
            title ? (
                <Title size="small" Element="h6" style="contrast">
                    {title}
                </Title>
            ) : undefined
        }
        content={
            description ? (
                <Text typography="paragraph-2-regular" style="contrast">
                    {description}
                </Text>
            ) : undefined
        }
        buttonBase={
            buttonBase ? (
                <Button mode="primary" style="contrast" size="small" {...buttonBaseProps}>
                    {buttonBase}
                </Button>
            ) : undefined
        }
        buttonAdditional={
            buttonAdditional ? (
                <Button mode="secondary" style="contrast" size="small" {...buttonAdditionalProps}>
                    {buttonAdditional}
                </Button>
            ) : undefined
        }
    />
);

export default MagritteBannerFacade;
